import React, { useEffect } from 'react';
import { Box, TextInput, Group, ActionIcon, Divider, Select, MultiSelect, Text } from '@mantine/core';
// import { X } from 'tabler-icons-react';
import { X, Plus, Trash } from "tabler-icons-react";

function MathEpreuve({ form, index, onRemove }) {
    const choixPath = `epreuves.${index}.choices`;

    useEffect(() => {
        // Initialize choices if they don't exist
        if (!form.values.epreuves[index].choices) {
            form.setFieldValue(choixPath, []);
        }
    }, []);

    const addChoice = () => {
        form.insertListItem(choixPath, "");
    };

    const removeChoice = (cidx) => {
        form.removeListItem(choixPath, cidx);
    };

    const calculateResult = () => {
        const consigne = form.values.epreuves[index].consigne;
        let result = null;
        let currentNumber = null;
        let currentOperation = null;

        for (const item of consigne) {
            const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
            if (parsedItem?.type === "n" && parsedItem?.value !== "") {
                const num = parseFloat(parsedItem.value);
                if (currentNumber === null) {
                    currentNumber = num;
                } else if (currentOperation) {
                    switch (currentOperation) {
                        case "+":
                            currentNumber += num;
                            break;
                        case "-":
                            currentNumber -= num;
                            break;
                        case "*":
                            currentNumber *= num;
                            break;
                        case "/":
                            if (num !== 0) {
                                currentNumber /= num;
                            } else {
                                return "Division par zéro impossible";
                            }
                            break;
                    }
                    currentOperation = null;
                }
            } else if (parsedItem?.type === "s" && ["+", "-", "*", "/"].includes(parsedItem.value)) {
                currentOperation = parsedItem.value;
            }
        }

        return currentNumber !== null ? currentNumber : "Calcul impossible";
    };

    const updateThirdNumberWithResult = () => {
        const result = calculateResult();
        form.setFieldValue(`epreuves.${index}.result`, result);

        const consigne = form.values.epreuves[index].consigne;
        const numberInputs = consigne.filter(item => {
            const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
            return parsedItem?.type === "n";
        });

        if (numberInputs.length >= 3) {
            const thirdNumberIndex = consigne.findIndex(
                (item, idx) => {
                    const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
                    return parsedItem?.type === "n" &&
                        consigne.slice(0, idx).filter(i => {
                            const parsedI = typeof i === 'string' ? JSON.parse(i) : i;
                            return parsedI?.type === "n";
                        }).length === 2;
                }
            );
            if (thirdNumberIndex !== -1) {
                // Add equals sign before the last number if it doesn't exist
                const equalsIndex = thirdNumberIndex - 1;
                if (equalsIndex >= 0) {
                    const equalsItem = {
                        type: "s",
                        value: "="
                    };
                    form.setFieldValue(`epreuves.${index}.consigne.${equalsIndex}`, JSON.stringify(equalsItem));
                }

                const updatedItem = {
                    type: "n",
                    value: result.toString()
                };
                form.setFieldValue(`epreuves.${index}.consigne.${thirdNumberIndex}`, JSON.stringify(updatedItem));
            }
        }
    };

    const validateNumber = (value) => {
        if (value === "") return true;
        return /^-?\d*\.?\d*$/.test(value);
    };

    const handleValueChange = (idx, value, type) => {
        const updatedItem = {
            type,
            value
        };
        form.setFieldValue(`epreuves.${index}.consigne.${idx}`, JSON.stringify(updatedItem));
    };

    return (
        <Box key={index}>
            <TextInput
                placeholder="Mettre la consigne"
                mb={10}
                radius={10}
                {...form.getInputProps(`epreuves.${index}.titre`)}
            />
            <Group position="apart">
                <Group>
                    {form.values.epreuves[index].consigne.map((item, idx) => {
                        const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;

                        if (parsedItem?.type === "s") {
                            return (
                                <Select
                                    key={idx}
                                    value={parsedItem.value}
                                    onChange={(value) => handleValueChange(idx, value, "s")}
                                    placeholder="Choisir le signe"
                                    data={["+", "-", "*", "/", "="]}
                                    style={{ flex: 1 }}
                                    onBlur={updateThirdNumberWithResult}
                                />
                            );
                        } else {
                            return (
                                <TextInput
                                    key={idx}
                                    value={parsedItem.value}
                                    placeholder="Saisir le nombre"
                                    radius={10}
                                    w={150}
                                    onKeyPress={(e) => {
                                        const value = e.target.value + e.key;
                                        if (!validateNumber(value)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (validateNumber(value)) {
                                            handleValueChange(idx, value, "n");
                                        }
                                    }}
                                    onBlur={updateThirdNumberWithResult}
                                />
                            );
                        }
                    })}
                </Group>
                <Group>
                    <MultiSelect
                        {...form.getInputProps(`epreuves.${index}.correction_dp`)}
                        placeholder="sélectionner"
                        data={
                            form.values.epreuves[index].consigne
                                .filter(item => {
                                    const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
                                    return parsedItem?.type === "n" && parsedItem?.value !== "";
                                })
                                .map(item => {
                                    const parsedItem = typeof item === 'string' ? JSON.parse(item) : item;
                                    return parsedItem.value;
                                })
                        }
                    />
                    <ActionIcon color="red" onClick={() => onRemove(index)}>
                        <X size="1rem" />
                    </ActionIcon>
                </Group>
            </Group>

            <Box mt={20}>
                <Text mb={5}>Choix possibles</Text>
                <Group spacing="xs" wrap="wrap" align="center">
                    {form.values.epreuves[index].choices?.map((choice, cidx) => (
                        <Group key={cidx} spacing={5}>
                            <TextInput
                                placeholder="Ex : 12"
                                w={100}
                                value={choice}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (validateNumber(value)) {
                                        form.setFieldValue(`epreuves.${index}.choices.${cidx}`, value);
                                    }
                                }}
                                onKeyPress={(e) => {
                                    const value = e.target.value + e.key;
                                    if (!validateNumber(value)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <ActionIcon color="red" onClick={() => removeChoice(cidx)} variant="subtle">
                                <Trash size="1rem" />
                            </ActionIcon>
                        </Group>
                    ))}
                    <ActionIcon onClick={addChoice} color="blue" variant="outline">
                        <Plus size="1rem" />
                    </ActionIcon>
                </Group>
            </Box>

            <Divider my={20} />
        </Box>
    );
}

export default MathEpreuve; 